import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Hide crawler-only prerender content from users while keeping it in the DOM for crawlers
const prerender = document.getElementById("prerender-content");
if (prerender) (prerender as HTMLElement).style.display = "none";

createRoot(document.getElementById("root")!).render(<App />);
